/** Readable-or-not, the simple way: WCAG relative luminance contrast ratio.
 *  Used to warn when a chosen text colour disappears on a chosen button
 *  colour. It only warns — the organization's choice is always saved. */
const channel = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

const rgb = (hex) => {
    const value = String(hex || '').replace('#', '');
    const full = value.length === 3 ? value.split('').map((c) => c + c).join('') : value;
    if (full.length !== 6 || /[^0-9a-f]/i.test(full)) return null;
    return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

export const contrastRatio = (a, b) => {
    const one = rgb(a);
    const two = rgb(b);
    if (!one || !two) return null;
    const lum = (c) => 0.2126 * channel(c[0]) + 0.7152 * channel(c[1]) + 0.0722 * channel(c[2]);
    const [hi, lo] = [lum(one), lum(two)].sort((x, y) => y - x);
    return (hi + 0.05) / (lo + 0.05);
};

/** Below 3:1 a large bold label is genuinely hard to read. */
export const poorContrast = (bg, fg) => {
    const ratio = contrastRatio(bg, fg);
    return ratio !== null && ratio < 3;
};
